import {
  CreditReport,
  CreditReportAccountOverview,
  CreditReportCollection
} from "types/landlord/reports";

/** Reshape a collection tradeline into the third-party collection shape the collections sections render. */
const toCollection = (
  account: CreditReportAccountOverview
): CreditReportCollection => ({
  account_number: account.account_number,
  client_name: account.account_name ?? account.original_creditor_name,
  status: account.rate,
  narrative_codes: account.narrative_codes,
  date_reported: account.date_reported,
  original_amount: account.high_credit,
  balance: account.balance,
  creditor_classification: account.creditor_classification,
  date_of_first_delinquency: account.date_major_first_delinquency_reported
});

/**
 * Third-party collections when the bureau reports them (TransUnion), otherwise
 * the tradelines flagged as collection accounts (Equifax usually omits the
 * `collections` segment and reports collections as trades).
 */
export const resolveCollections = (
  report?: Pick<CreditReport, "collections" | "collection_accounts">
): CreditReportCollection[] => {
  if (report?.collections?.length) return report.collections;

  return report?.collection_accounts?.map(toCollection) ?? [];
};
